exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#event-selection .event-logo{max-height:20px;max-width:50px}.fa-fast-spin{-webkit-animation:fa-spin 1s infinite linear;animation:fa-spin 1s infinite linear}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-6550659d!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/event_selection.vue
// module id = 350
// module chunks = 0